module.exports = __webpack_public_path__ + "static/media/dark-mode-image.b11d15b1.svg";